module.exports = __webpack_public_path__ + "static/media/contact-bg.6aa4cde9.jpg";